<template>
  <div class="wrapper">
    <div id="edit-grid">
      <div id="sidebar" v-if="!collapse">
        <!-- FAB -->

        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          @click="newCard"
          class="icon"
          id="new-card"
          v-if="!preview"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div class="card" id="limited-sidebar">
          <h2>{{ collection.name }}</h2>
          <div id="card-list">
            <input
              class="input"
              type="text"
              id="search"
              v-model="searchTerm"
              placeholder="Filter cards..."
            />

            <details>
              <summary>Advanced</summary>

              <div style="padding: 18px">
                Filter by type:
                <ul style="list-style: none">
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.oldLearn"
                    />
                    <label for="new">Old learning cards</label>
                  </li>
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.newLearn"
                    />
                    <label for="learn">New learning cards</label>
                  </li>
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.habit"
                    />
                    <label for="habit">Habits</label>
                  </li>
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.check"
                    />
                    <label for="check">Checks</label>
                  </li>
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.todo"
                    />
                    <label for="todo">Todos</label>
                  </li>
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.startedBook"
                    />
                    <label for="startedBook">Started books</label>
                  </li>
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.pendingBook"
                    />
                    <label for="pendingBook">Pending books</label>
                  </li>
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.articleList"
                    />
                    <label for="article">Articles</label>
                  </li>
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.standard"
                    />
                    <label for="standard">Other</label>
                  </li>
                  <li>
                    <input
                      class="input"
                      type="checkbox"
                      v-model="activeTypes.project"
                    />
                    <label for="project">Project</label>
                  </li>
                </ul>
                <!-- button to set all activeTypes to false -->
                <button @click="disableAllActiveTypes">Disable all</button>
              </div>
              <button @click="downloadCurrent" class="button">
                Download currently visible notes
              </button>
            </details>

            <button
              v-for="listCard in filteredCards"
              :key="listCard.id"
              :class="
                listCard.type +
                ' card-list-card ' +
                (listCard.id === card.id ? 'active' : '')
              "
              @click="openCard(listCard.id)"
            >
              <span v-if="listCard.front">
                {{ listCard.front.substring(0, 38) }}
              </span>
              <span v-else> Unnamed Card </span>

              <span v-if="listCard.front.length > 38">...</span>
            </button>

            <small> {{ filteredCards.length }} cards </small>
          </div>
        </div>
      </div>

      <button
        class=""
        id="collapse-button"
        v-if="!collapse"
        @click="collapse = true"
      >
        <span>Collapse</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"
          />
        </svg>
      </button>

      <button class="" id="collapse-button" v-else @click="collapse = false">
        <span>Expand</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"
          />
        </svg>
      </button>

      <div id="edit" v-if="$store.state.editCards.length > 0 && card.id">
        <code v-for="tag in cardTags" :key="tag.id">
                    {{ tag.name }}
                </code>
        <div class="card" id="edit-card" :class="card.type">
          <div id="card-heading-wrapper">
            <h2
              class="card-heading"
              v-if="card.type === 'learn'"
              id="label-front"
            >
              Front
            </h2>
            <h2 class="card-heading" v-else>Content</h2>
            <div id="preview-button-wrapper">
              <button class="button small-button" @click="activatePreview">
                Preview
              </button>

              <CardView :id="card.id" v-if="preview" class="overlay-card" />
              
              <div class="overlay" v-if="preview"></div>
              <svg
                @click="deactivatePreview"
                v-if="preview"
                id="deactivatePreview"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <div id="preview-button-wrapper">
              <button class="button small-button" @click="toggleConnectDialog">
                Connect
              </button>

              <div class="overlay-card card queue-card" v-if="connectDialog">
                <div>
                  <h2>Connect a card</h2>
                  <h3>Search all decks</h3>
                </div>

                <input
                  class="input w-full"
                  type="text"
                  placeholder="Enter a term..."
                  v-model="globalSearchTerm"
                  @input="globalSearch"
                />
                <div class="flex-list">
                  <button
                    v-for="listCard in globalSearchResults"
                    :key="listCard._id"
                    class="card-list-card search-result"
                    @click="connectCard(listCard)"
                  >
                    <span v-if="listCard._front">
                      {{ listCard._front.substring(0, 100) }}
                    </span>
                    <span v-else> Unnamed Card </span>
                    <span v-if="listCard._front.length > 100">...</span>
                  </button>
                </div>
              </div>
              <div class="overlay" v-if="connectDialog"></div>
              <svg
                @click="toggleConnectDialog"
                v-if="connectDialog"
                id="deactivatePreview"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <span class="sep">|</span>
            <div id="save-wrapper">
              <span
                id="save-text"
                class="normal-text"
                :class="{ alert: savingState == 'not saved' }"
                >card {{ savingState }}</span
              >

              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
                :class="{ 'icon-grey': savingState !== 'not saved' }"
                @click="saveCard()"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                />
              </svg>
            </div>

            <span class="sep">|</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @click="deleteCard"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </div>

          <textarea
            class="card-content"
            name="front"
            id="card-front"
            v-model="card.front"
            @input="savingState = 'not saved'"
            @change="saveCard"
          ></textarea>
          <div>
            <h2
              class="card-heading"
              v-if="card.type === 'learn'"
              id="label-back"
            >
              Back
            </h2>
          </div>
          <textarea
            name="back"
            class="card-content"
            id=""
            v-model="card.back"
            v-if="card.type === 'learn'"
            @input="savingState = 'not saved'"
            @change="saveCard"
          ></textarea>
          <select name="card-select" id="card-select" v-model="card.type">
            <option :value="type.name" v-for="type in types" :key="type.name">
              {{ type.name }}
            </option>
          </select>
          <div id="card-buttons" class="button-list">
            <button
              class="card-button button"
              :class="{ 'button-primary': card.type === type.name }"
              @click="setCardType(type.name)"
              v-for="type in types"
              :key="type.name"
            >
              {{ type.label }}
            </button>
          </div>
          <div id="type-info">
            <span v-if="this.card.type == 'learn'">
              'Learn' cards are classic flash cards. <br />
              They contain a front site with a question and a back site with an
              answer.
            </span>
            <span v-if="this.card.type == 'habit'">
              Use the 'Habit' card type get prompted to do habits. You decide
              how often you want to do a habit.
            </span>
            <span v-if="this.card.type == 'check'">
              'Check' cards are similar to 'Habit' cards, but refer to the past,
              like in "Did you sleep enough last night?"
            </span>
            <span v-if="this.card.type == 'todo'">
              'Todo' cards are for one-time actions you have to do - they
              disappear after you complete them.
            </span>
            <span v-if="this.card.type == 'readingList'">
              'Book' cards are for books you want to read.
              <br />
              Five items of your reading list stay in rotation at a time and
              after you finish a book another one from the list is picked.
            </span>
            <span v-if="this.card.type == 'articleList'">
              'Articles' cards are for articles, posts, papers and shorter
              pieces of text that you want to read.
              <br />
              Unlike books, you will be prompted to read articles in one go
              instead of page by page.
            </span>

            <span v-if="this.card.type == 'standard'">
              'Other' cards are for cards that are not of any of the other
              types. <br />
              They are occasionally shown and could be used for cool quotes or
              paintings that you like.
            </span>

            <span v-if="this.card.type == 'project'">
            Every day, one of your projects is randomly chosen.
          </span>

          </div>

          <p
            v-if="this.card.type == 'habit' || this.card.type == 'check'"
            id="interval-selector"
            class="extra-selector"
          >
            Show every
            <input
              class="input"
              type="number"
              v-model="card.interval"
              id="interval"
              default="1"
              @change="saveCard"
            />

            <span @click="switchUnit" class="switchableText">
              {{ card.unit }} </span
            >.
          </p>
          <p
            v-if="this.card.type == 'readingList'"
            id="started-reading-wrapper"
            class="extra-selector"
          >
            <input
              class="input"
              type="checkbox"
              :checked="card.startedReading"
              @change="setReadingStarted($event)"
              name="started-reading"
              id="started-reading"
            />
            <label for="started-reading">Started Reading</label>
          </p>
          <details id="card-details">
            <summary>Show Card Details</summary>
            occurrences: {{ card.occurrences }} <br />
            {{ convertUnixTimestampToReadableDatetime(card.nextShown) }} <br />
            <span v-if="card.type == 'learn'">
              Interval: {{ card.interval }}, Ease: {{ card.ease }}, Repetitions:
              {{ card.repetition }}
            </span>
          </details>
          <div id="card-checkbox">
            <input
              class="input"
              type="checkbox"
              v-model="card.priority"
              name="priority"
              id="priority"
              @change="saveCard"
            />
            <label for="priority">Priority Card</label>
          </div>
        </div>
        <div v-if="false">
        <button
              v-for="listCard in connectedCards"
              :key="listCard.id"
              :class="
                listCard.type +
                ' card-list-card ' +
                (listCard.id === card.id ? 'active' : '')
              "
              @click="openCard(listCard.id)"
            >
              <span v-if="listCard.front">
                {{ listCard.front.substring(0, 38) }}
              </span>
              <span v-else> Unnamed Card </span>

              <span v-if="listCard.front.length > 38">...</span>
            </button>
      </div>
    </div>
     
    </div>
  </div>
</template>
<script>
import { uuid } from "vue-uuid";
import { supabase } from "../supabase";
import Markdown from "vue3-markdown-it";
import CardView from "../components/CardView.vue";


export default {
  data() {
    return {
      collapse: false,
      types: [
        {
          name: "learn",
          label: "Learn",
        },
        {
          name: "habit",
          label: "Habit",
        },
        {
          name: "check",
          label: "Check",
        },
        {
          name: "todo",
          label: "Todo",
        },
        {
          name: "readingList",
          label: "Book",
        },
        {
          name: "articleList",
          label: "Article",
        },
        {
          name: "standard",
          label: "Other",
        },
        {
          name: "project",
          label: "Project",
        }
      ],
      activeTypes: {
        oldLearn: true,
        newLearn: true,
        habit: true,
        check: true,
        todo: true,
        startedBook: true,
        pendingBook: true,
        articleList: true,
        standard: true,
        project: true
      },
      searchTerm: "",
      loaded: false,
      imageUploading: false,
      lastCardType: "learn",
      lastEditedCard: null,
      savingState: "saved",
      preview: false,
      connectDialog: false,
      front: "...loading",
      back: "...loading",
      globalSearchTerm: "",
      globalSearchResults: [],
      connectedCards: [],
      stickers: [],
      cardTags: [],
    };
  },
  components: {
    Markdown,
    CardView
  },
  created() {
    this.$store.dispatch("getCards");
  },
  mounted() {
    if (!this.card) {
      // set current edit card to 0
      this.$store.commit("setCurrentEditCardId", 0);
      // if card is still not set, create a new card
      if (!this.card) {
        const newCard = {
          id: uuid.v4(),
          type: "standard",
          front: "New Card",
          back: "",
          nextShown: new Date() / 1000,
          ease: 0,
          interval: 1,
          repetition: 0,
          unit: "days",
          pack_id: collection.id,
          occurrences: 0,
        };
        this.$store.commit("addCard", newCard);
      }
    }
    this.getConnectedCards();
  },
  methods: {
    getConnectedCards: async function() {
      try {
        let { data, error } = await supabase
          .from("card_connections")
          .select("*")
          .eq("card_sender", this.card.id);
        if (error) throw error;
        // loop through data and set property front to front_receiver
        for (let i = 0; i < data.length; i++) {
          
          data[i].front = data[i].front_receiver;
          data[i].id = data[i].card_receiver;
          
        }
        this.connectedCards = data;
           
      } catch (error) {
        
      }
      try {
        // do the same for card_receiver
        const { data, error } = await supabase
          .from("card_connections")
          .select("*")
          .eq("card_receiver", this.card.id);

        if (error) throw error;
        // loop through data and set property front to front_sender
        for (let i = 0; i < data.length; i++) {
          data[i].front = data[i].front_sender;
          data[i].id = data[i].card_sender;
        }
        this.connectedCards = this.connectedCards.concat(data);
        
      } catch(error) {
        
      }
    },
    getConnectedTags: async function() {
      try {
        console.log("trying to get tags for card id", this.card.id);
        const { data, error } = await supabase
          .from("tags_cards")
          .select("*")
          .eq("card_id", this.card.id)
        if (error) throw error;
        // now we have a list of relevsant connections, which holds the tag_id
        // for each tag_id, we need to get the tag name
        // then we need to add the tag name to the cardTags array
        this.cardTags = [];
        for (let i = 0; i < data.length; i++) {
          const { data: tagData, error: tagError } = await supabase
            .from("tags")
            .select("*")
            .eq("id", data[i].tag_id)
          if (tagError) throw tagError;
          this.cardTags.push(tagData[0]);
        }
        console.log("card tags:", this.cardTags);
      } catch (error) {
        console.log("card tag error", error);
      }
    },
    connectCard: async function (receiver) {
      // add to supabase backend
      // new row in card_connections
      this.connectDialog = false;
      const { data, error } = await supabase.from("card_connections").insert([
        {
          card_sender: this.card.id,
          card_receiver: receiver.id,
          front_sender: this.card.front,
          front_receiver: receiver.front,
        },
      ]);
      this.getConnectedCards();
      // TODO: pop up message

    },
    newCard: function () {
      const card = {
        user_id: supabase.auth.currentUser.id,
        id: uuid.v4(),
        type: this.lastCardType,
        front: "",
        back: "",
        nextShown: new Date() / 1000,
        ease: 0,
        interval: 1,
        repetition: 0,
        unit: "days",
        pack_id: this.collection.id,
        occurrences: 0,
        startedReading: false,
      };
      this.$store.dispatch("addCard", card);
      // scroll the card-list element to the top
      const cardList = document.getElementById("card-list");
      cardList.scrollTop = 0;
    },
    openCard: function (id) {
      
      this.$store.commit("setCurrentEditCardId", id);
      // if the windows inner width is less thant 1140px, set collapse true
      if (window.innerWidth < 1140) {
        this.collapse = true;
      }
    },
    deleteCard: function () {
      this.$store.dispatch("deleteCard", this.card);
    },
    setCardType: function (type) {
      this.card.type = type;
      this.lastCardType = type;
      this.saveCard();
    },
    setReadingStarted: function (event) {
      this.card.startedReading = event.target.checked;
      this.saveCard();
    },
    switchUnit: function () {
      if (this.card.unit === "days") {
        this.card.unit = "hours";
      } else {
        this.card.unit = "days";
      }
      this.saveCard();
    },

    saveCard() {
      this.savingState = "saving...";
      this.lastEditedCard = this.card;
      this.$store.dispatch("updateCard", this.card).then(() => {
        this.savingState = "saved";
      });
    },
    convertUnixTimestampToReadableDatetime(timestamp) {
      if (timestamp > 1) {
        return "next due at: " + new Date(timestamp * 1000).toLocaleString();
      } else {
        return "fresh card - due now";
      }
    },
    async uploadImage(event) {
      this.imageUploading = true;
      const file = event.target.files[0];
      try {
        const { data, error } = await supabase.storage
          .from("user-images")
          .upload(`${supabase.auth.currentUser.id}/${file.name}`, file);

        if (error) throw error;
        
        this.card.front += `{{ ${file.name} }}`;
        this.savingState = "not saved";
        this.saveCard();
        this.imageUploading = false;
      } catch (error) {
        console.warn(error);
      }
    },

    activatePreview() {
      this.preview = true;
    },
    deactivatePreview() {
      this.preview = false;
      this.front = "...loading";
      this.back = "...loading";
    },
    toggleConnectDialog() {
      this.connectDialog = !this.connectDialog;
    },
    async downloadCurrent() {
      // create a csv file from filtered cards
      // first, create a header row with "front" , "back", "type"
      let csv = "front,back,type\n";
      // then, loop through the cards and add a row for each card
      // encapsulate each cell in double quotes

      this.filteredCards.forEach((card) => {
        csv += `"${card.front.replace(/"/g, '""')}","${card.back.replace(
          /"/g,
          '""'
        )}","${card.type}"\n`;
      });
      // download the csv file
      const blob = new Blob([csv], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "cards.csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    disableAllActiveTypes() {
      this.activeTypes.oldLearn = false;
      this.activeTypes.newLearn = false;
      this.activeTypes.habit = false;
      this.activeTypes.check = false;
      this.activeTypes.todo = false;
      this.activeTypes.startedBook = false;
      this.activeTypes.pendingBook = false;
      this.activeTypes.articleList = false;
      this.activeTypes.standard = false;
      this.activeTypes.project = false;
    },
    globalSearch: async function () {
      // use "global_search" rpc with id_of_user and search_term
      if (this.globalSearchTerm.length > 1) {
        try {
          // the resulting data will have _id instead of id and _front instead of front, convert it to the right format
          console.log("searching for", this.globalSearchTerm);
          const { data, error } = await supabase.rpc("global_search", {
            id_of_user: supabase.auth.currentUser.id,
            search_term: this.globalSearchTerm,
          });
          if (error) throw error;
          console.log("search result data", data);
          this.globalSearchResults = data;
        } catch (error) {
          console.log("error", error);
        }
      }
    },
  },
  computed: {
    collection: function () {
      return this.$store.getters.getCurrentCollection || null;
    },
    card: {
      get() {

        const card = this.$store.getters.getCurrentEditCard || {}
        if (card.id) {
          this.getConnectedCards();
          this.getConnectedTags();
        }
        return card
      },
      set(newCard) {
        this.saveCard(newCard);
      },
    },
    filteredCards: function () {
      return this.$store.state.editCards
        .filter((card) => {
          // go through the list of optional activeTypes filters and we
          // match a condition but fail to match, return false
          // most things we can just catch, but for some we need a special check
          if (this.activeTypes[card.type] === false) {
            return false;
          }
          // catch old and new learning cards
          if (card.type === "learn") {
            // check if the card is a new learning card and activeTypes.new is false
            if (card.occurrences > 0 && this.activeTypes.oldLearn === false) {
              return false;
            }
            // check if the card is an old learning card and activeTypes.old is false
            if (card.occurrences === 0 && this.activeTypes.newLearn === false) {
              return false;
            }
          }

          // do the same with books, use card.interval
          if (card.type === "readingList") {
            if (card.startedReading && this.activeTypes.startedBook === false) {
              return false;
            }
            if (!card.startedReading && this.activeTypes.pendingBook === false) {
              return false;
            }
          }
          if (
            (card.front + card.back)
              .toLowerCase()
              .includes(this.searchTerm.toLowerCase())
          ) {
            return true;
          }
        })
        .reverse();
    },
  },
  watch: {
    lastEditedCard: function (newCard) {
      if (newCard) {
        this.$store.dispatch("addToScores", {
          vote: 99,
          score: 1,
          skipNote: "",
        });
      }
    },
  },
};
</script>
